<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import type { Person } from '~/layers/forms/models'
import { Form } from '~/layers/forms/models'

interface Props {
  modelValue: Omit<Person, 'identification'>
  customerAsInsured?: boolean | null
  insurable?: Insurable
}

const props = defineProps<Props>()

const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)

const { RemoteConfigurationStore } = stores()
const heading = computed(
  () =>
    `Información del ${RemoteConfigurationStore.value?.ramoEnum === 'Personas' ? 'asegurado' : 'contratante'}`
)
</script>

<template>
  <FormsGlobalContainer :identifier="Form.customer">
    <FormsGlobalTitle
      :text="heading"
      icon-class="icon-[ph--user-bold]"
    />

    <FormsGlobalPersonBaseForm
      :model-value="model"
      :validation-scope="Form.customer"
      :insurable
    >
    </FormsGlobalPersonBaseForm>
    <slot name="aditional-fields" />
  </FormsGlobalContainer>
</template>
